import { UserCancellationInterceptOutcomeTotalsMapper } from "@vendor-app/mappers/UserCancellationInterceptOutcomeTotals/mapper";

import UserCancellationInterceptOutcomeTotalsGateway from "./gateway";

const userCancellationInterceptOutcomeTotalsGateway = new UserCancellationInterceptOutcomeTotalsGateway(
  new UserCancellationInterceptOutcomeTotalsMapper()
);

export default userCancellationInterceptOutcomeTotalsGateway;
